export enum YourTeamGridColumnId {
    USER_NAME = 'userName',
    SUPER_GROUP = 'superGroup',
    PERIOD = 'period',
    OVERALL_SCORE = 'overallScore',
}
